<script>

    import { toast } from 'bulma-toast'
    import { modalStore, pickupsStore } from '../stores'

    import PickupsService from '../$services/pickups.svelte'
    import DateMehtod from '../$methods/date.methods'

    import Search from '../$components/input.search.svelte'
    import Select from '../$components/select.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    let query = {
        page: 0,
        find: null,
        admin: true,
    }
    let metadata = {}
    let loading = false

    getPickups()

    async function getPickups() {

        loading = true
        const resp = await PickupsService.getPickups(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pickupsStore.set(resp.data.pickups)
        metadata = resp.data.metadata
    }

</script>

<Table
    items={ $pickupsStore.length }
    total={ metadata.total }
    { loading }
    skeletonCols={8}
    bind:metadata
    bind:page={ query.page }
    on:change={ getPickups }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={ getPickups } />
        </div>
        <div class="header-actions">
            <Select bind:value={ query.status } on:change={ getPickups }
                text="Estatus"
                size="small"
                options={[
                    {value: 'pending', text: 'Pendiente'},
                    {value: 'success', text: 'Agendada'},
                    {value: 'canceled', text: 'Cancelada'},
                ]}
            />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Usuario</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Proveedor</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-barcode"></i></span>
                    <span>Guía</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-file-invoice"></i></span>
                    <span>Folio</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Fecha</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $pickupsStore as pickup, index}
            <tr>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                <td>{ pickup.status }</td>
                <td>
                    <div class="td-stack">
                        <div>{ pickup.user.name }</div>
                        <small>{ pickup.user.email }</small>
                    </div>
                </td>
                <td>{ pickup.provider }</td>
                <td>{ pickup.guide }</td>
                <td>{ pickup.folio }</td>
                <td>{ DateMehtod.dateLarge(pickup.date) }</td>
                <td>
                    <Button on:click={() => modalStore.open('pickup', 'modal', pickup)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
